// src/components/SaveConsent.jsx
// 取り込み前の保存確認【2026-09-11】
//
// 取り込みは「サーバーのDBに書く」操作なので、押す前に何が残るのかを見せて、
// 明示的に同意をもらう。学生の氏名・メール・感想の本文まで入るものがあり、
// 黙って保存してよいものではない。
//
// 既定値の考え方:
//   名簿      … ON。出席率の分母がここからしか作れないので、保存しないと
//                システムが成り立たない。取り込む=保存する、が前提の操作
//   それ以外  … OFF。点数も感想も、サーバーに置かずに済ませる運用があり得る
//                （レポート出力の「名簿を置かない運用」と同じ考え方）。
//                置くなら毎回、意識して置いてもらう
//
// チェックが外れている間は、取り込みボタンを押せなくする。

import React from 'react';

export default function SaveConsent({ checked, onChange, title, items, note, defaultsOn }) {
  return (
    <div style={{
      border: '1px solid ' + (checked ? '#bfdbfe' : '#fcd34d'),
      background: checked ? '#eff6ff' : '#fffbeb',
      borderRadius: 10, padding: '0.7rem 0.9rem', margin: '0.9rem 0',
    }}>
      <div style={{ fontSize: '0.88rem', fontWeight: 700,
                    color: checked ? '#1e40af' : '#92400e' }}>
        {title || 'このアプリ（サーバー）に保存されます'}
      </div>

      {items && items.length > 0 && (
        <ul style={{ margin: '0.4rem 0 0', paddingLeft: '1.2rem',
                     fontSize: '0.82rem', color: '#4b5563', lineHeight: 1.7 }}>
          {items.map((t, i) => <li key={i}>{t}</li>)}
        </ul>
      )}

      {note && (
        <div style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: '0.4rem',
                      lineHeight: 1.6 }}>
          {note}
        </div>
      )}

      <label style={{ display: 'flex', gap: '0.45rem', alignItems: 'flex-start',
                      marginTop: '0.6rem', cursor: 'pointer', fontSize: '0.88rem' }}>
        <input type="checkbox" checked={checked}
               onChange={e => onChange(e.target.checked)}
               style={{ marginTop: '0.2rem' }} />
        <span>
          上の内容をサーバーに保存することを確認しました
          {!defaultsOn && (
            <span style={{ color: '#92400e', fontSize: '0.8rem', marginLeft: '0.35rem' }}>
              （既定はオフです）
            </span>
          )}
        </span>
      </label>
    </div>
  );
}
